import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedContact } from '@repo/redux/actions/ui';
import { Pill } from '@repo/components/containers';
import { useContactPersonOptions } from '@repo/hooks';
import SelectOptionModal from '../SelectOption';
import styles from './ContactPerson.module.scss';

export default function ContactPersonModal({ closeModal }: { closeModal: () => void }) {
  const currentSelectedContact = useSelector(selectSelectedContact);
  const selectedContact = useMemo(() => currentSelectedContact, []);
  const [options, onModalOpen] = useContactPersonOptions(selectedContact.id, {
    onOptionSelect: closeModal,
    optionClassName: styles.option,
  });

  return (
    <SelectOptionModal
      closeModal={closeModal}
      header={
        <>
          Reach out
          <Pill contact={selectedContact} maxWidth={160} />
        </>
      }
      options={options}
      onModalOpen={onModalOpen}
    />
  );
}
